<template>
  <div class="fast-collect-index-container">
    <div class="fast-collect-index-back">
      <el-button @click="goBack" type="primary"><jee-icon iconClass="fanhui"></jee-icon> 返回</el-button>
    </div>
    <div class="fast-collect-index-template">
      <div class="fast-collect-index-template-title">
        <jee-icon iconClass="caijimoban" :style="{fontSize: '23px', marginRight: '10px'}"></jee-icon>采集模板
      </div>
      <div class="fast-collect-index-template-list">
        <ul>
          <li :key="index" v-for="(item, index) in list" @click="goTo(item.modelType)" @mousemove="jeeMove(index)" @mouseout="jeeOut" :class="{'jee-color': hoverIndex === index }">
            <img :src="item.logoImg + '.png'" alt="">
            <div class="fast-collect-index-template-sub-title">{{ item.title }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import FastCollectData from './FastCollectData'
export default {
  name: 'FastCollectIndex',
  data () {
    return {
      list: FastCollectData,
      // 未开始、采集中样式切换id
      hoverIndex: ''
    }
  },
  methods: {
    // 鼠标移动
    jeeMove (index) {
      this.hoverIndex = index
    },
    // 鼠标离开
    jeeOut () {
      this.hoverIndex = ''
    },
    goTo (type) {
      this.$router.push({ name: 'FastCollectDetail', query: { type: type } })
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.fast-collect-index-container{
  .fast-collect-index-back{
    margin-bottom: 20px;
    .el-button{
      font-size:16px;
      width: 90px;
      padding: 9px 0;
    }
    .jee-svg-icon{
      vertical-align: -0.1em;
      font-size: 14px;
    }
  }
  .fast-collect-index-template-title{
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-size:20px;
    font-weight:normal;
    color:rgba(51,51,51,1);
    background:rgba(249,249,249,1);
    border-radius:4px;
    margin-bottom:20px;
    .jee-svg-icon{
      margin:0 10px;
      vertical-align: -.2em;
    }
  }
  .fast-collect-index-template-list{
    ul{
      display: flex;
      flex-wrap: wrap;
      li{
        cursor: pointer;
        width:225px;
        background:rgba(249,249,249,1);
        border-radius:4px;
        margin-right:20px;
        margin-bottom: 10px;
        padding: 0 5px;
        color:rgba(102,102,102,1);
        display: flex;
        align-items: center;
        height: 70px;
        img{
          width: 60px;
          height: 60px;
          vertical-align: middle;
          margin-right: 12px;
        }
        .fast-collect-index-template-sub-title{
          flex: 1;
          font-size:14px;
          font-weight:300;
        }
        &:hover{
          background:rgba(243,243,243,1);
        }
      }
    }
  }
}
</style>
